<template>
  <div class="home-menu-box">
     <van-row v-if="safeWapConfig.option_switch && safeWapConfig.option_switch == 0">
      <van-col :span="12">
        <div class="menu-small" @click="toPage('recharge')">
          <span>{{ $t("home.menu2") }}</span>
        </div>
        
      </van-col>
      <van-col :span="12">

        <div class="menu-small" @click="toPage('withdrawal')">
          <span>{{ $t("home.menu3") }}</span>
        </div>
      </van-col>
    </van-row>
    <van-row v-else>
      <van-col :span="16">
        <div class="menu-big" @click="toPage('options')">
          <p>{{ $t("home.menu1") }}</p>
          <span>{{ $t("home.menu1desc") }}</span>
        </div>
      </van-col>
      <van-col :span="8">
        <div class="menu-small" @click="toPage('recharge')">
          <span>{{ $t("home.menu2") }}</span>
        </div>
        <div class="menu-small" @click="toPage('withdrawal')">
          <span>{{ $t("home.menu3") }}</span>
        </div>
      </van-col>
    </van-row>
   
    <van-row>
      <van-col :span="menulsttmp.length == 0 ? 24 : 12" style="display: none">
        <div
          class="menu-small menuicon1"
          :class="menulsttmp.length == 0 ? 'menu-small-all' : 'menu-small'"
          style="float: left"
          @click="jumpUrl(safeWapConfig.custom_service)"
        >
          <span>{{ $t("home.menu4") }}</span>
        </div>
      </van-col>
      <div v-if="menulsttmp.length > 0">
        <div v-for="(item, index) in menulsttmp" :key="index">
          <van-col
            :span="
              menulsttmp.length % 2 == 1 && index == menulsttmp.length - 1
                ? 24
                : 12
            "
          >
            <div
              :class="
                item.icon +
                ' ' +
                (menulsttmp.length % 2 == 1 && index == menulsttmp.length - 1
                  ? 'menu-small-all'
                  : 'menu-small')
              "
              :style="
                index % 2 != 1 && index != menulsttmp.length - 1
                  ? 'float: left'
                  : ''
              "
              @click="toPage(item.page)"
            >
              <span>{{ item.text }}</span>
            </div>
          </van-col>
        </div>
      </div>
    </van-row>
  </div>
</template>

<script>
export default {
  name: "HomeMenus",
  inject: ["app"],
  computed: {
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
  },
  watch: {
    app(newval) {
      console.log(newval);
    },
  },
  data() {
    return {
      timer: null,
      menulsttmp: [],
      menulst: [
        { icon: "menuicon1", page: "kefu", text: this.$t("home.menu4") }, //客服
        { icon: "menuicon2", page: "exchangeb", text: this.$t("home.menu5") }, //闪兑
        { icon: "menuicon3", page: "loans", text: this.$t("home.menu6") }, //贷款
        { icon: "menuicon4", page: "lockming", text: this.$t("home.menu7") }, //矿机
        { icon: "menuicon5", page: "staking", text: this.$t("home.menu8") }, //质押
        { icon: "menuicon6", page: "transfer", text: this.$t("home.menu9") }, //用户转账
        {
          icon: "menuicon7",
          page: "changemoney",
          text: this.$t("footer.change"),
        }, //用户转账
      ],
    };
  },
  mounted() {
    this.initPage();
    if (!this.safeWapConfig.flash_exchange_status) {
      const that = this;
      this.$nextTick(() => {
        that.timer = setInterval(() => {
          that.initPage();
        }, 500);
      });
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    initPage() {
      if (this.safeWapConfig.flash_exchange_status) {
        if (this.timer) clearInterval(this.timer);
      }
      this.menulsttmp = [];
      this.menulst.forEach((item) => {
        if (item.page == "kefu"  && this.safeWapConfig.custom_service && this.safeWapConfig.custom_service.length > 0)
          this.menulsttmp.push(item);

        if (
          item.page == "exchangeb" &&
          this.safeWapConfig.flash_exchange_status == 1
        )
          this.menulsttmp.push(item);
        if (item.page == "loans" && this.safeWapConfig.loan_switch == 1)
          this.menulsttmp.push(item);
        if (item.page == "lockming" && this.safeWapConfig.machine_switch == 1)
          this.menulsttmp.push(item);
        if (item.page == "staking" && this.safeWapConfig.staking_switch == 1)
          this.menulsttmp.push(item);
        if (
          item.page == "transfer" &&
          this.safeWapConfig.Internal_transfer_status == 1
        )
          this.menulsttmp.push(item);
        if (
          item.page == "changemoney" &&
          this.safeWapConfig.account_transfer_status == 1
        )
          this.menulsttmp.push(item);
      });
    },
    toPage(item) {
      if (item == "recharge" && this.safeWapConfig.recharge_status != 1) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service);
          return;
        } else {
          this.$toast.fail(this.$t("common.forserver"));
          return;
        }
      }
      if (item == "withdrawal" && this.safeWapConfig.withdrawal_status != 1) {
        if (this.safeWapConfig.custom_service.length > 0) {
          this.jumpUrl(this.safeWapConfig.custom_service);
          return;
        } else {
          this.$toast.fail(this.$t("common.forserver"));
          return;
        }
      }
      if (item == "kefu") {
        this.app.show_servers = true
        //this.jumpUrl(this.safeWapConfig.custom_service);
        return;
      }
      this.$router.push({ name: item }, () => {});
    },
    jumpUrl(url) {
      console.log(url)
      this.app.show_servers = true
      //window.open(url, '_blank', 'noopener,noreferrer');
      //return;
      /*
      const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        window.location.replace(url);
      } else {
        if (url.includes("https://")) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
        */
    },
  },
};
</script>

<style>
</style>
